import { slice } from '../slices/guestShare';

const nameSpace = slice.name;

export const isLoading = (state: RootState) => state[nameSpace].isLoading;
export const totalCount = (state: RootState) => state[nameSpace].totalCount;
export const page = (state: RootState) => state[nameSpace].page;
export const invitationList = (state: RootState) => state[nameSpace].invitationList;
